import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const borderRadius = 8;
const rowSpacing = 12;
const borderSize = 2;
const borderColor = "#ccc";

export const Table = styled.table`
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
  font-family: Arial;
  margin: 5px 0;
`;

export const THead = styled.thead`
  height: 30px;
`;

export const HeaderRow = styled.tr`
  th:first-child {
    border-top-left-radius: ${borderRadius}px;
    border-bottom-left-radius: ${borderRadius}px;
    border-left: none;
    border-right: none;
  }

  th:last-child {
    border-top-right-radius: ${borderRadius}px;
    border-bottom-right-radius: ${borderRadius}px;
    border-left: none;
    border-right: none;
    white-space: nowrap;
  }

  th:before {
    content: "";
    position: absolute;
    width: 2px;
    height: 70%;
    background: ${borderColor};
    right: 0;
    top: 15%;
  }

  th:last-child:before {
    display: none;
  }
`;

export const Header = styled.th`
  text-align: ${({ textAlign }) => textAlign ?? "left"};
  background-color: #e8e8e8;
  padding: 0 5px;
  min-width: ${({ minWidth }) => (minWidth !== undefined ? minWidth : "auto")};
  max-width: ${({ maxWidth }) => (maxWidth !== undefined ? maxWidth : "auto")}
  position: relative;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  white-space: nowrap;
`;

export const OrderIconWrapper = styled.span`
  height: 14px;
  width: 14px;
  font-size: 14px;
  margin-left: 5px;
`;

export const TBody = styled.tbody``;

export const Row = styled.tr`
  border: 0;

  td {
    position: relative;
    height: 60px;
  }

  @media (max-width: 1550px) {
    td {
      height: 90px;
    }
  }

  td:before {
    content: "";
    position: absolute;
    width: 1px;
    height: calc(100% - ${rowSpacing * 2}px);
    background: ${borderColor};
    right: 0;
    top: calc(15% + ${rowSpacing / 2}px);
  }

  td:last-child:before {
    display: none;
  }

  td:first-child > div {
    border-top-left-radius: ${borderRadius}px;
    border-bottom-left-radius: ${borderRadius}px;
    padding-left: 0;
  }

  td:last-child > div {
    border-top-right-radius: ${borderRadius}px;
    border-bottom-right-radius: ${borderRadius}px;
    padding-right: 0;
    border-right: ${borderSize}px solid ${borderColor};
  }

  td .nowrap {
    white-space: nowrap;
  }
`;

export const Column = styled.td`
  height: inherit;
  width: ${({ width }) => (width !== undefined ? width : "auto")};
`;

export const ColumnContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - ${rowSpacing / 2}px);
  margin-top: 5px;
  border-top: ${borderSize}px solid ${borderColor};
  border-bottom: ${borderSize}px solid ${borderColor};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
`;

export const PropostaPedidoWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Status = styled.div`
  height: calc(100% + 3px);
  width: 7px;
  margin-top: -2px;
  border-top-left-radius: ${borderRadius}px;
  border-bottom-left-radius: ${borderRadius}px;
  background-color: ${({ color }) => color ?? "black"};
`;

export const DoubleRow = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const FlexWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: ${({ direction }) => direction ?? "row"};
  justify-content: ${({ justify }) => justify ?? "center"};
  align-items: ${({ align }) => align ?? "center"};
  color: ${({ color }) => color ?? "black"};
  font-weight: ${({ fontWeight }) => fontWeight ?? "normal"};

  :nth-child(2) {
    margin-top: 2px;
  }
`;

export const SvgIcon = styled(ReactSVG)`
  fill: #00a2e0 !important;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const FloatingLink = styled.div`
  ${({ theme }) => css`
    font-family: roboto;
    border: none !important;
    border-radius: 0px !important;
    background-color: white;
    height: 8rem;
    width: 10rem;
    position: absolute;
    right: 10rem;
    top: 0;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    z-index: 9999;

    p {
      line-height: 2rem;
      height: 2.5rem;
      margin: 0.5rem 1rem 0 1rem;
      border-bottom: 1px solid ${theme.colors.grayThird};
      font-weight: bold;
    }
    div {
      display: flex;
      line-height: 5rem;
      text-align: center;
      cursor: pointer;
      #icon-link {
        margin: 1.3rem 0 0 1.5rem;
      }
    }
  `}
`;
export const LinkProposalView = styled(NavLink)`
  ${({ theme }) => css`
    display: flex;
    line-height: 5rem;
    text-align: center;
    cursor: pointer;
    #icon-link {
      margin: 1.3rem 0 0 1.5rem;
    }
  `}
`;
